export const COMMUNITY_ACCESS_DENIED_EVENT = 'community:access-denied'
